import React from "react";
import ArchitectureFlow from "./ArchitectureFlow";
import { directionBFlows } from "../../content/directionB";

export default function SimpliDevHomepagePreview() {
  return (
    <div className="direction-b-simplidev-preview">
      <div className="direction-b-simplidev-preview__flow">
        <span className="direction-b-mono-label">Representative governed SDLC</span>
        <ArchitectureFlow flow={directionBFlows.simplidevHomepage} label="Representative governed SimpliDev software development lifecycle" />
        <div className="direction-b-simplidev-preview__rework">
          <span>Bounded rework</span>
          <i aria-hidden="true">↶</i>
          <strong>Verify / Review → Implement</strong>
        </div>
      </div>
      <div className="direction-b-simplidev-preview__governance">
        <span className="direction-b-mono-label">Governed by SimpliDev</span>
        <p>Model discretion inside explicit workflow, tool, and evaluation boundaries.</p>
        <div className="direction-b-simplidev-preview__controls">
          <span>Phase-aware policy</span>
          <span>Role-scoped agents</span>
          <span>Durable state</span>
          <span>Mission Control · operational coordination</span>
          <span>MCP / enterprise tools</span>
          <span>Evaluation · human control</span>
        </div>
      </div>
    </div>
  );
}
